export const PROCEDURES_FIELDS = {
  ID: "id",
  VERSION_ID: "versionId",
  APPLICATION_ID: "applicationId",
  SELFIE_TYPES: "selfieTypes",
  ACCEPTABLE_DOCUMENTS: "acceptableDocuments",
  IMPORTANTS: "importants",
  COMMENT: "comment"
};

export const ADDITIONAL_INFO_FIELDS = {
  COMMENT: "comment"
};

export const ACCEPTABLE_DOCUMENT_FIELDS = {
  DOCUMENT_TYPE: "documentType",
  APPLICABLE_RULES: "applicableRules",
  COUNTRIES_ISO_2: "countriesIso2",
  ADDITIONAL_INFO: "additionalInfo"
};

export const IMPORTANTS_FIELDS = {
  RULE: "rule",
  COUNTRIES_ISO_2: "countriesIso2",
  ADDITIONAL_REGISTRATION_VALIDATION_RULE:
    "additionalRegistrationValidationRule"
};

// ---- enums from BE ----

export const APPLICABLE_RULE = {
  MRZ_REQUIRED: "MrzRequired",
  BACK_SIDE_REQUIRED: "BackSideRequired",
  ONLY_SPECIFIC_COUNTRIES_ACCEPTABLE: "OnlySpecificCountriesAcceptable",
  BOTH_SIDES_REQUIRED: "BothSideRequired",
  PROVISIONAL_OR_LEARNER_DL_ACCEPTED: "ProvisionalOrLearnerDlAccepted",
  ACCEPT_PERMANENTLY: "AcceptPermanent",
  ACCEPT_TEMPORARY: "AcceptTemporary"
};

export const DOCUMENT_TYPE = {
  PASSPORT: "Passport",
  ID_CARD: "Id", // TODO: when BE will make changes adjust value to IdCard
  DRIVER_LICENSE: "DrivingLicense", // TODO: when BE will make changes adjust value to DriverLicense
  LOCAL_PASSPORT: "LocalPassport",
  RESIDENCE_PERMIT: "ResidencePermit"
};

export const IMPORTANT_RULE = {
  HAS_PROHIBITED_COUNTRIES: "HasProhibitedCountries",
  HAS_PROHIBITED_NATIONALITIES: "HasProhibitedNationalities",
  ACCEPT_EXPIRATION_DATE_TODAY: "AcceptExpirationDateToday",
  NO_SCANNED_PICS_BAD_MEDIA_FORMAT: "NoScannedPicsBadMediaFormat",
  NO_SCANNED_PICS_FRAUD_ATTEMPT: "NoScannedPicsFraudAttempt",
  NO_PRINT_SCREENS: "NoPrintscreens",
  NO_SCREEN_CAPTURE: "NoScreenCapture",
  NO_PRINT_SCREENS_CAPTURE: "NoPrintScreensCapture",
  NO_BLACK_OR_WHITE_PICTURES: "NoBlackOrWhitePictures",
  ADDITIONAL_REGISTRATION_VALIDATION_REQUIRED:
    "AdditionalRegistrationValidationRequired"
};

export const SELFIE_TYPE = {
  MOVING_SELFIE_REQUIRED: "MovingSelfieRequired",
  PHOTO_STANDARD_NOT_FROM_DOCUMENT: "PhotoStandardNotFromDocument",
  PHOTO_STANDARD_HOLDING_DOCUMENT: "PhotoStandardHoldingDocument",
  NO_REQUIRED: "NoRequired"
};
